var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCake2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 61.045C11.5 51.812 13.4789 49.8333 22.7117 49.8333H69.2883C78.5212 49.8333 80.5 51.812 80.5 61.045V69.2882C80.5 78.5212 78.5212 80.4999 69.2883 80.4999H22.7117C13.4789 80.4999 11.5 78.5212 11.5 69.2882V61.045Z",
    stroke: "#FEE069",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 49.8333V44.6813C23 36.297 24.797 34.5 33.1813 34.5H58.8187C67.2029 34.5 69 36.297 69 44.6813V49.8333",
    stroke: "#FEE069",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 34.4999V26.8333",
    stroke: "#FEE069",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 13.4167V11.5",
    stroke: "#FEE069",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 34.4999V26.8333",
    stroke: "#FEE069",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 13.4167V11.5",
    stroke: "#FEE069",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46 34.4999V26.8333",
    stroke: "#FEE069",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13.4167V11.5",
    stroke: "#FEE069",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 61.4854C12.6855 61.38 13.9475 61.3333 15.3333 61.3333C21.5057 61.3333 24.4943 65.1666 30.6667 65.1666C36.839 65.1666 39.8276 61.3333 46 61.3333C52.1724 61.3333 55.1609 65.1666 61.3333 65.1666C67.5058 65.1666 70.4942 61.3333 76.6667 61.3333C78.0524 61.3333 79.3143 61.38 80.5 61.4854",
    stroke: "#FEE069",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake2);
export default __webpack_public_path__ + "static/media/cake2.72358896f23660e282b0b83685d7a845.svg";
export { ForwardRef as ReactComponent };